import { React } from "react";
import RateCanvas from "./RateCanvas";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Paper,
  Button,
  TextField,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

const Legend = ({ hideMetUid }) => {
  return (
    <Box
      sx={{
        marginTop: 0,
      }}
    >
      <Typography
        variant="h6"
        align="center"
        sx={{ lineHeight: 1.1, marginBottom: "2px" }}
      >
        Легенда
      </Typography>
      <TableContainer component={Paper} sx={{ maxHeight: "calc(100% - 40px)" }}>
        <Table
          sx={{
            "& .MuiTableCell-root": {
              padding: "6px 8px", // Уменьшаем отступы
            },
          }}
        >
          <TableBody sx={{ border: "1px solid #ccc" }}>
            <TableRow>
              <TableCell
                colSpan={2}
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "1.0rem",
                  padding: "10px",
                }}
              >
                в списке каналов
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ backgroundColor: "rgba(255, 0, 0, 0.15)" }}>
                канал
              </TableCell>
              <TableCell> программа на 1 день</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ backgroundColor: "rgba(255, 255, 0, 0.15)" }}>
                канал
              </TableCell>
              <TableCell>программа на 3 дня</TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ color: "red" }}>канал</TableCell>
              <TableCell>редактируемый канал</TableCell>
            </TableRow>

            <TableRow>
              <TableCell
                colSpan={2}
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "1.0rem",
                  padding: "10px",
                }}
              >
                {" "}
                в списке фильмов
              </TableCell>
            </TableRow>
            {!hideMetUid && (
              <TableRow>
                <TableCell
                  sx={{ backgroundColor: "#E0F7FA", color: "#0000EE" }}
                >
                  имя фильма
                </TableCell>
                <TableCell>нет met_uid</TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell sx={{ color: "red" }}>2024</TableCell>
              <TableCell>год больше 2023</TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{
                  color: "blue",
                  backgroundColor: "#f5f5f3",
                  textAlign: "center",
                }}
              >
                ***
              </TableCell>
              <TableCell>фильм состоит в блоке сиквел</TableCell>
            </TableRow>

            <TableRow>
              <TableCell colSpan={2} sx={{ textAlign: "center" }}>
                <RateCanvas rates={{}} legendMode={true} />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Legend;
